export const buildVersion = {
  version: '1.4',
  buildNumber: 66,
  commit: '68186ada2',
};
